import { t } from 'ttag'

import { COLLEGE_CREATE_PLAN } from './colleges'

import * as h2Api from '../h2Api'

export const OCCUPATION_LOADED = 'OCCUPATION_LOADED'
export const OCCUPATION_LOADED_LOG = 'OCCUPATION_LOADED_LOG'
export const CLEAR_SELECTED = 'OCC_CLEAR_SELECTED'
export const RATE_OCCUPATION = 'OCC_RATE_OCCUPATION'
export const PROFILE_SELECT_LOADED = 'PROFILE_SELECT_LOADED'
export const CACHE_INITIAL = 'PROFILE_CACHE_SET_INITIAL'
export const SET_OCCUPATIONS_FOR_COMPARISON = 'SET_OCCUPATIONS_FOR_COMPARISON'
export const OCCUPATION_COMPARISON = 'OCCUPATION_COMPARISON'
export const SELECT_OCCUPATION_FOR_COMPARISON = 'SELECT_OCCUPATION_FOR_COMPARISON'
export const REMOVE_OCCUPATION_FOR_COMPARISON = 'REMOVE_OCCUPATION_FOR_COMPARISON'
export const CLEAR_COMPARISON = 'CLEAR_COMPARISON'
export const OCCUPATION_COMPARISON_SET_ERROR = 'OCCUPATION_COMPARISON_SET_ERROR'
export const SELECT_MODAL_OCCUPATION = 'SELECT_MODAL_OCCUPATION'
export const LOCAL_LOADED = 'OCCUPATION_LOCAL_LOADED'
export const SELECT_COMPARISON_REGION = 'SELECT_COMPARISON_REGION'
export const LOAD_COMPARISON_REGIONS = 'LOAD_COMPARISON_REGIONS'
export const LOCAL_LOADING = 'OCCUPATION_LOCAL_LOADING'

export const VIDEO_VIEW_LOGGED = 'OCCUPATION_VIDEO_VIEW_LOGGED'
export const VIDEOS_LOADED = 'OCCUPATION_VIDEOS_LOADED'
export const VIDEO_DETAIL_LOADED = 'OCCUPATION_VIDEO_DETAIL_LOADED'

export const videoListing = (start = 0, filter = {}) => {
  return h2Api.post(`/occupations/videos`, { ...filter, start })({ type: VIDEOS_LOADED })
}

export const setForComparison = onetSocs => {
  return { type: SET_OCCUPATIONS_FOR_COMPARISON, onetSocs }
}

export const selectForComparison = onetSoc => (dispatch, getState) => {
  const comparisons = getState().occupations.comparison.selectedOccupations.length

  if (comparisons === 4) {
    alert(t`You already have four items selected`)

    return false
  }

  return Promise.resolve(dispatch({ type: SELECT_OCCUPATION_FOR_COMPARISON, onetSoc }))
}

export const toggleOccupationModal = modalName => dispatch => {
  return Promise.resolve(dispatch({ type: SELECT_MODAL_OCCUPATION, modalName }))
}

export const selectLocalTab = (onetSoc, tab) => dispatch => {
  dispatch({ type: LOCAL_LOADING })

  return dispatch(
    h2Api.get(`/occupations/profile/${onetSoc}/opportunities/${tab}`)({
      type: LOCAL_LOADED,
      selectedLocalTab: tab
    })
  )
}

export const removeForComparison = onetSoc => dispatch => {
  return Promise.resolve(dispatch({ type: REMOVE_OCCUPATION_FOR_COMPARISON, onetSoc }))
}

export const clearComparison = () => dispatch => {
  return Promise.resolve(dispatch({ type: CLEAR_COMPARISON }))
}

export const compareOccupations = occupations => dispatch => {
  const items = typeof occupations === 'string' ? [occupations] : occupations

  if (!items) {
    return Promise.resolve(
      dispatch({
        type: OCCUPATION_COMPARISON_SET_ERROR,
        error: t`No occupations specified for comparison`
      })
    )
  }

  dispatch({
    type: OCCUPATION_COMPARISON_SET_ERROR,
    error: null
  })

  return dispatch(
    h2Api.post('/occupations/compare', { onetSoc: items })({
      type: OCCUPATION_COMPARISON
    })
  )
}

export const rateOccupation = (occupation, ratingType) => dispatch => {
  //console.log("RATING", occupation, ratingType)
  return dispatch(
    h2Api.put(`/user/rate/onet/${occupation.onetSoc}`, {
      rating: ratingType
    })({ type: RATE_OCCUPATION, onetSoc: occupation.onetSoc })
  )
}

export const selectComparisonRegion = (occupation, comparisonRegion) => dispatch => {
  //console.log("RATING", occupation, ratingType)
  return dispatch(
    h2Api.post(`/occupations/profile/${occupation.onetSoc}/lmi/comparison`, {
      region: comparisonRegion
    })({ type: SELECT_COMPARISON_REGION })
  )
}

export const retrieveComparisonRegions = () => dispatch => {
  //console.log("RATING", occupation, ratingType)
  return dispatch(
    h2Api.get(`/occupations/lmi/regions`)({
      type: LOAD_COMPARISON_REGIONS
    })
  )
}

export const createPlan = (institutionId, typeId) => dispatch => {
  return dispatch(
    h2Api.post(`/occupations/plan/${institutionId}`, {
      planType: typeId
    })({
      type: COLLEGE_CREATE_PLAN
    })
  )
}

export const flagOccupation = (occupation, ratingType) => dispatch => {
  //console.log("RATING", occupation, ratingType)
  return dispatch(
    h2Api.put(`/user/flag/onet/${occupation.onetSoc}`, {
      rating: ratingType
    })({ type: RATE_OCCUPATION, onetSoc: occupation.onetSoc })
  )
}

export const loadOccupation = occupationId => dispatch => {
  dispatch({ type: CLEAR_SELECTED })

  return dispatch(
    h2Api.get(`/occupations/profile/${occupationId}`)({ type: OCCUPATION_LOADED })
  )
}

export const logOccupationVideoView = (occupationId, fileName) => {
  return h2Api.post(`/occupations/profile/${occupationId}/video/log`, { fileName })({
    type: VIDEO_VIEW_LOGGED
  })
}
